/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto } from '../models/Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantAccountDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantAccountDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantSecurityQuestionsAnswersDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantSecurityQuestionsAnswersDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateAddressByParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateAddressByParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateDetailByParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateDetailByParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto';
import type { Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantSecurityQuestionsAnswersDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantSecurityQuestionsAnswersDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentByParticipantDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentByParticipantDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountResponseDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountResponseDto';
import type { Wealthlane_CustomerService_Dtos_Response_ResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Response_ResponseDto';
import type { Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountResponseDto } from '../models/Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantSharedService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentByParticipantDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantEmployment(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantEmploymentByParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-employment',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantTax(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-tax',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantSharedParticipantBrokerAccount(): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantBrokerAccount_ParticipantBrokerAccountResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-shared/participant-broker-account',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountResponseDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantSharedParticipantTransferAgentAccount(): CancelablePromise<Wealthlane_CustomerService_Dtos_TransferAgent_ParticipantTransferAgentAccountResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-shared/participant-transfer-agent-account',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantPersonalDetailsByParticipant(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateDetailByParticipantDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantDetailDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/personal-details-by-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantAddressesByParticipant(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateAddressByParticipantDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantAddressDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/addresses-by-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantAddress(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-address',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantPersonalDetail(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ViewParticipantPersonalDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-personal-detail',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantSecurityQuestionsAnswersDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantSecurityQuestionsAnswers(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantSecurityQuestionsAnswersDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-security-questions-answers',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantCompanyLogo(): CancelablePromise<Wealthlane_CustomerService_Dtos_CompanyLogo_CompanyLogoBlobDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/company-logo',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantForOnboarding(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-for-onboarding',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantSecurityQuestionsAnswersDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantParticipantsSecurityAnswers(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantSecurityQuestionsAnswersDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_UpdateParticipantSecurityQuestionsAnswersDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant/participants-security-answers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param phoneNumber 
     * @returns Wealthlane_CustomerService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantSharedPersonContactNumber(
phoneNumber?: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-shared/person-contact-number',
            query: {
                'phoneNumber': phoneNumber,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantAccountDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantParticipantAccountNumber(): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantAccountDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/participant-account-number',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantContactNumber(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/contact-number',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantSocialSecurityNumber(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/social-security-number',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantDateOfBirth(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant/date-of-birth',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
